import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../../services/i18n/language';
import { CompanyAssignee, CompanyService } from '../../../services/api/company';

export interface AssigneeFilterValue {
  /** Конкретный сотрудник или null. */
  id: number | null;
  /** Только «не назначен». */
  unassigned: boolean;
}

export const EMPTY_ASSIGNEE_FILTER: AssigneeFilterValue = { id: null, unassigned: false };

/** Фильтр списка по ответственному: все / не назначен / сотрудник компании нужной роли. */
@Component({
  selector: 'app-assignee-filter',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './assignee-filter.html',
  styleUrl: './assignee-filter.scss'
})
export class AssigneeFilterComponent implements OnInit, OnChanges, OnDestroy {
  /** manager: менеджеры, operator: операторы. */
  @Input() kind: 'manager' | 'operator' = 'manager';
  @Input() value: AssigneeFilterValue = EMPTY_ASSIGNEE_FILTER;
  @Output() changed = new EventEmitter<AssigneeFilterValue>();

  options: CompanyAssignee[] = [];
  /** '' все, 'none' не назначен, иначе id сотрудника. */
  selected = '';

  private subscriptions = new Subscription();

  constructor(
    private companyService: CompanyService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(this.languageService.getTranslations().subscribe(() => this.cdr.markForCheck()));
    const request = this.kind === 'manager' ? this.companyService.getManagers() : this.companyService.getOperators();
    request.subscribe({
      next: options => {
        this.options = options;
        this.cdr.markForCheck();
      },
      error: () => (this.options = [])
    });
  }

  ngOnChanges(): void {
    this.selected = this.value.unassigned ? 'none' : this.value.id !== null ? String(this.value.id) : '';
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  t(key: string, fallback: string): string {
    const value = this.languageService.translate(key);
    return value && value !== key ? value : fallback;
  }

  get label(): string {
    return this.kind === 'manager'
      ? this.t('company.assign.managerLabel', 'Ответственный менеджер')
      : this.t('company.assign.operatorLabel', 'Ответственный оператор');
  }

  change(value: string): void {
    this.selected = value;
    this.changed.emit({
      id: value && value !== 'none' ? Number(value) : null,
      unassigned: value === 'none'
    });
  }
}
